import React from "react";
import "./DividerLine.css";

export const DividerLine = ({ vertical = false, gap = undefined, isEmpty = false }) => (
    <div
        className={`dividerLine ${vertical ? "dividerVertical":""} ${isEmpty ? "isEmpty":""}`}
        style={{ margin: gap }}
    />
);
